import React from 'react';

import 'rc-slider/assets/index.css';
import './slider.css';
import 'rc-tooltip/assets/bootstrap.css';

import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';

const Handle = Slider.Handle;

const handle = props => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip prefixCls="rc-slider-tooltip" overlay={value} visible={dragging} placement="top" key={index}>
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

const wrapperStyle = { margin: '0 10px 40px' };

class CustomSlider extends React.Component {
  render() {
    return (
      <div style={wrapperStyle}>
        <Slider
          min={this.props.min}
          max={this.props.max}
          defaultValue={this.props.defaultValue}
          handle={handle}
          onChange={this.props.onChange}
          marks={this.props.marks}
        />
      </div>
    );
  }
}

export default CustomSlider;



// WEBPACK FOOTER //
// ./src/components/Form/slider.js